import React, { useState } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
import { FaTimes, FaBan } from 'react-icons/fa';

export default function RecusarEvento({ eventoId, eventoNome, onClose, onSuccess }) {
    const token = localStorage.getItem('token');
    const [motivo, setMotivo] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!motivo.trim()) {
            toast.error('Por favor, informe o motivo da recusa');
            return;
        }

        setLoading(true);
        try {
            const response = await api({
                method: 'post',
                action: '/evento/recusarBackoffice',
                token: token,
                data: {
                    evento_id: eventoId,
                    motivo: motivo.trim()
                }
            });

            if (response.data && response.data.status) {
                toast.success('Evento recusado com sucesso. Notificações enviadas aos responsáveis.');
                if (onSuccess) {
                    onSuccess();
                }
                onClose();
            } else {
                toast.error(response.data?.error || 'Erro ao recusar evento');
            }
        } catch (error) {
            console.error('Erro ao recusar evento:', error);
            toast.error(error.response?.data?.error || 'Erro ao recusar evento');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="mb-3">
                <h5 className="mb-3">
                    <FaBan className="text-danger me-2" />
                    Recusar Evento
                </h5>
                <p className="text-muted">
                    O evento <strong>"{eventoNome}"</strong> será recusado e os responsáveis na agência serão notificados.
                </p>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="motivo" className="form-label">
                        <strong>Motivo da Recusa *</strong>
                    </label>
                    <textarea
                        id="motivo"
                        className="form-control"
                        rows="5"
                        value={motivo}
                        onChange={(e) => setMotivo(e.target.value)}
                        placeholder="Descreva o motivo da recusa do evento..."
                        required
                        disabled={loading}
                    />
                    <small className="form-text text-muted">
                        Este motivo será enviado aos responsáveis na agência através de uma notificação.
                    </small>
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                        disabled={loading}
                    >
                        <FaTimes className="me-2" />
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-danger"
                        disabled={loading || !motivo.trim()}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Processando...
                            </>
                        ) : (
                            <>
                                <FaBan className="me-2" />
                                Recusar Evento
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

